export default 'addBuildingPage';
